// Stub for @sentry-internal/replay and @sentry-internal/replay-canvas
// when imported statically from @sentry/browser.
// The real modules are lazy-loaded via replay.ts.
export function replayIntegration() {
  return { name: 'Replay' };
}
export function replayCanvasIntegration() {
  return { name: 'ReplayCanvas' };
}
export function getReplay() {
  return undefined;
}
